import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import moment from 'moment';
import dataProvider from '@/data/dataProvider.json';
import Base from '@/components/common/base'
import Code from '@/components/common/code'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import store from './store'
import interceptor from './interceptor/interceptor'
import VueI18n from 'vue-i18n'
import {ko_KR, en_US} from './locales/locale.js';
//import * as VeeValidate from 'vee-validate'
import { ValidationProvider, ValidationObserver} from 'vee-validate';
import VTooltip from 'v-tooltip' //추가 Vue.use(VTooltip); //추가

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.use(moment);
window.moment = moment
Vue.config.productionTip = false
Vue.prototype.$http = axios;
Vue.prototype.$dataProvider = dataProvider;
Vue.mixin(Base);
Vue.mixin(Code);
Vue.use(VueToast, {position: 'top-right'});
window.store = store;
Vue.prototype.$currentEmployee = null;
Vue.use(VueI18n);
Vue.use(VTooltip);
interceptor();

const i18n = new VueI18n({
  locale: 'ko_KR',
  messages: {
    en_US : en_US,
    ko_KR: ko_KR
  }
})
var _ = require('lodash');
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  checkMobile();
  next();
  
})

if(document.getElementById("datapicker")){
  $("#datepicker").datepicker({
    dateFormat: 'yy-mm-dd', //날짜 표시 형식 설정
    showOtherMonths: true, //이전 달과 다음 달 날짜를 표시
    showMonthAfterYear:true, //연도 표시 후 달 표시
    changeYear: true, //연도 선택 콤보박스
    changeMonth: true, //월 선택 콤보박스
    showOn: "both", //button:버튼을 표시하고,버튼을 눌러야만 달력 표시 ^ both:버튼을 표시하고,버튼을 누르거나 input을 클릭하면 달력 표시
    yearSuffix: "년", //연도 뒤에 나오는 텍스트 지정
    monthNamesShort: ['1','2','3','4','5','6','7','8','9','10','11','12'],
    monthNames: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
    dayNamesMin: ['일','월','화','수','목','금','토'],
    dayNames: ['일요일','월요일','화요일','수요일','목요일','금요일','토요일'],
    minDate: "-1M", // -1D:하루전, -1M:한달전, -1Y:일년전
    maxDate: "+1M", // +1D:하루후, -1M:한달후, -1Y:일년후
    buttonImage: "image/calendar.gif", //버튼에 띄워줄 이미지 경로
    buttonImageOnly: true, //디폴트 버튼 대신 이미지 띄워줌
    buttonText: "선택", //버튼 마우스오버 시 보이는 텍스트
  });
}

